import { render, staticRenderFns } from "./turnstile.vue?vue&type=template&id=f1781f30&"
import script from "./turnstile.vue?vue&type=script&lang=js&"
export * from "./turnstile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1781f30')) {
      api.createRecord('f1781f30', component.options)
    } else {
      api.reload('f1781f30', component.options)
    }
    module.hot.accept("./turnstile.vue?vue&type=template&id=f1781f30&", function () {
      api.rerender('f1781f30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/settings/turnstile.vue"
export default component.exports